
import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '../../../services/local-storage';
import { LoaderService } from '../../../services/Spinner.service';
import { SharedService } from '../../../services/shared.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PopupSegmentComponent } from '../../shared/components/popupAdmin/popup-segment.component';

@Component({
    selector: 'app-dashboard',
    templateUrl: './segments.component.html',
     providers: [ SharedService,PopupSegmentComponent]
    // styleUrls: ['./dashboard.component.scss']

})
export class SegmentsComponent implements OnInit {
searchText ='';
data = [];
itemsTotalAdv = 0;
page =1;
searchSegText ='';
 objLoaderStatus: boolean = false;
 errormessage = '';
charFlag :boolean = false;
  message ="";
  searchmessage = "";

  column = "";
  numberColumn : number =0;
  order : string ="ASC";
  sortingOrder = [];

    constructor(private localstorage: LocalStorage,
     private loaderService: LoaderService,
    private formBuilder: FormBuilder,
    private shareService: SharedService,
     private PopupSegment: PopupSegmentComponent, 
    private dialogService:DialogService) {
    
 var i=0;
  for(i=0;i<3;i++){
    this.sortingOrder[i] = true;
  }
    
    }

    ngOnInit() {
      var x= document.getElementById('id1');
       x.classList.toggle("submenuActive"); 
      this.loaderService.loaderStatus.subscribe((val: boolean) => {
      this.objLoaderStatus = val;
    });
this.localstorage.setStorage("country",'');

    var token = this.localstorage.getStorage("token");
        this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("master/segments?currentSize=25&sortColumn=name&sortOrder=ASC", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
            this.loaderService.displayLoader(false);

    }
         });
}
    allSegment(){
        this.page = 1;
   this.errormessage ="";
          this.searchmessage = "";
      this.searchText = '';
      this.itemsTotalAdv = 0;
       var token = this.localstorage.getStorage("token");
        this.loaderService.displayLoader(true);
  var i=0;
  for(i=0;i<3;i++){
    this.sortingOrder[i] = true;
  }
  this.column = "name";
  this.shareService.CallDatawithToken("master/segments?currentSize=25&sortColumn=name&sortOrder=ASC", null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
            this.loaderService.displayLoader(false);

    }
         });
    }

   deleteSegment(id){
        var token = this.localstorage.getStorage("token");
        //this.id = id;
        this.showConfirmDelete(id);
   }


   nextSegment(text,id,order,event){
       var order;
  if(text){
  this.column = text;
}
     if(id !== ''){
  this.numberColumn = id;
}

 var i=0;
  for(i=0;i<6;i++){
 
    if(this.numberColumn != i ){
    this.sortingOrder[i] = true;
  }
  }
if(order){
  this.order = order;
}
  
  if(this.column == ""){
  this.column = "name";
}

  if(this.order == 'DESC'){
this.sortingOrder[this.numberColumn] = false;
  }
  else{
this.sortingOrder[this.numberColumn] = true;
  }
this.itemsTotalAdv =0;
    var j=0;
    this.page = event;
           this.errormessage ="";
             this.searchmessage = "";
     var token = this.localstorage.getStorage("token");
    this.searchText = this.searchText.trim();

    if(this.searchText =='' || this.searchText == undefined){
               this.loaderService.displayLoader(true);

  this.shareService.CallDatawithToken("master/segments?currentSize=25&currentPage="+event+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
    this.data = result.data;
        this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    this.loaderService.displayLoader(false);

}
  
         });
    } 
    else{
         if(this.searchText.length<2){
this.errormessage = "Please enter minimum 2 characters";
this.charFlag = true;
       }
       else{
                  this.loaderService.displayLoader(true);

      this.shareService.CallDatawithToken("admin/searchSegment?currentSize=25&currentPage="+event+"&q="+this.searchText+"&sortColumn="+this.column+"&sortOrder="+this.order, null, token).subscribe((result) => {
    console.log(result.data);
    if(result.data){
      if(result.data.length>0){
    this.data = result.data;
    this.itemsTotalAdv = result.pagination.totalPages * result.pagination.currentSize;
    }else{
        this.searchmessage = "No records found";
      }
        this.loaderService.displayLoader(false);

    }
         });
    }
    }
    return event; 
    
            
}



         showDelete() {
            let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Segment Information', 
                message:"Segment Deleted Successfully",
              data: [],
            showcancel : false})
                .subscribe((isConfirmed)=>{
                 window.location.reload();
                });
        }

         showConfirmDelete(id){
                  var token = this.localstorage.getStorage("token");

let disposable = this.dialogService.addDialog(PopupSegmentComponent, {
                title:'Segment Information', 
                message:'Are you sure you want to delete the Segment?',
              data: [],
             showcancel :true})
                .subscribe((isConfirmed)=>{
                  if(isConfirmed){
                    this.loaderService.displayLoader(true);
this.shareService.CallDatawithToken("admin/deleteSegment?id="+id,{},token).subscribe((result) => {
    console.log(result.data);
    if(result.data.status == true){
      this.showDelete();    }
    this.loaderService.displayLoader(false);
});
                  }   
                });

        }
}



// WEBPACK FOOTER //
// ./src/app/admin/layout/segments/segments.component.ts